export class AnalyticsEvent {
  eventName: AnalyticsEventNames;
  eventValue: string;
  pageTitle: string;
  pageUrl: string;
  engagementTimeMs: number;
  experienceId: string;
  experienceType: string;
  screenRes: string;
  brandId: number;
  timestamp: number;
  datetime: string;
  timezone: string;
  sessionId: string;
  campaignId: number;
  rollId: string;
  tagId: string;
  languageCode: string;

  constructor(event: Partial<AnalyticsEvent>) {
    const requiredProps = [
      'eventName',
      'eventValue',
      'pageTitle',
      'pageUrl',
      'experienceId',
      'experienceType',
      'screenRes',
      'brandId',
      'timestamp',
      'datetime',
      'timezone',
      'sessionId',
      'campaignId',
      'rollId',
      'tagId',
      'languageCode',
    ];

    const missingParams = [];
    for (const prop of requiredProps) {
      if (!event[prop]) {
        missingParams.push(prop);
      }
    }

    if (missingParams.length) {
      throw new Error(
        `Missing required parameter(s): ${missingParams.join(', ')}`
      );
    }

    Object.assign(this, event);
  }
}

export enum AnalyticsEventNames {
  PAGE_VIEW = 'page_view',
  CLICK = 'click',
  LINK = 'link',
  SHARE = 'share',
  APP_EXIT = 'app_exit',
}
